var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.hasTooltip ? 'BasicTooltip' : 'span',{tag:"component",staticClass:"expert-icon",attrs:{"content":"Провожу экспертные консультации"}},[_c('SvgIcon',{attrs:{"icon":"expert","size":"24"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }